import type { ReactElement } from 'react';
import { NavLink } from 'react-router';

import { Icon, type IconName } from '@/shared/ui/icon';

import styles from './Sidebar.module.scss';

export interface NavigationItem {
  to: string;
  label: string;
  icon: IconName;
  end?: boolean;
}

interface NavigationGroupProps {
  title: string;
  items: ReadonlyArray<NavigationItem>;
  onNavigate: () => void;
}

function NavigationLink({
  item,
  onNavigate,
}: {
  item: NavigationItem;
  onNavigate: () => void;
}): ReactElement {
  return (
    <NavLink
      to={item.to}
      end={item.end ?? false}
      className={({ isActive }) => (isActive ? styles.active : styles.link)}
      onClick={onNavigate}
    >
      <Icon name={item.icon} />
      <span>{item.label}</span>
    </NavLink>
  );
}

export function NavigationGroup({ title, items, onNavigate }: NavigationGroupProps): ReactElement {
  return (
    <section className={styles.group} aria-label={title}>
      <h2 className={styles.caption}>{title}</h2>
      <ul className={styles.items}>
        {items.map((item) => (
          <li key={item.to}>
            <NavigationLink item={item} onNavigate={onNavigate} />
          </li>
        ))}
      </ul>
    </section>
  );
}
